import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { url } from "../link";
import Navbar from "../components/Navbar";
const Viewlaptop2025 = () => {
  const nav = useNavigate();
  const [data, setData] = useState([]);
  const [value, setValue] = useState([]);

  useEffect(() => {
    axios.post(url + "/edusphere/viewlaptop").then((response) => {
      setData(response.data);
      setValue(response.data);
    });
  }, []);

  const viewlaptop = (e) => {
    nav("/updatelaptop", { state: e });
  };

  const deletec = (e) => {
    axios.post(url + "/edusphere/deletelaptop", { id: e }).then(() => {
      axios.post(url + "/edusphere/viewlaptop").then((response) => {
        setData(response.data);
        setValue(response.data);
      });
    });
  };

  const searchdata = (e) => {
    const searchText = e.toLowerCase();
    const r = [];

    for (var k of value) {
      let v = 0;
      for (var n of k) {
        n = "" + n;
        if (n.toLowerCase().indexOf(searchText) !== -1) {
          v = 1;
          break;
        }
      }
      if (v === 1) {
        r.push(k);
      }
    }
    setData(r);
  };

  return (
    <div className="container-fluid mt-5">
      <Navbar />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Laptop Records</h4>
          <input
            type="search"
            onChange={(e) => searchdata(e.target.value)}
            className="form-control w-50"
            placeholder="Search laptops..."
          />
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover table-striped align-middle mb-0">
              <thead className="table-primary text-center">
                <tr>
                  <th>ID</th>
                  <th>Laptop Name</th>
                  <th>Addons</th>
                  <th>Given Date</th>
                  <th>Delivery Date</th>
                  <th>Commitment</th>
                  <th>PID</th>
                  <th>Received By</th>
                  <th>Status</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Balance</th>
                  <th>Title</th>
                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {data.map((d) => {
                  const imgSrc = `${url}/static/${d[9]}`;
                  return (
                    <tr key={d[0]}>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => viewlaptop(d)}
                        >
                          {d[0]}
                        </button>
                      </td>
                      <td>{d[1]}</td>
                      <td>{d[2]}</td>
                      <td>{d[3]}</td>
                      <td>{d[4]}</td>
                      <td>{d[5]}</td>
                      <td>{d[6]}</td>
                      <td>{d[7]}</td>
                      <td>{d[8]}</td>
                      <td>{d[12]}</td>
                      <td>{d[13]}</td>
                      <td>{d[17]}</td>
                      <td>{d[15]}</td>
                      <td>
                        {d[10] !== null ? (
                          <img
                            src={imgSrc}
                            alt="Laptop"
                            className="img-thumbnail"
                            width="80"
                          />
                        ) : (
                          <span className="text-muted">No Image</span>
                        )}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-danger me-2"
                          onClick={() => deletec(d[0])}
                        >
                          <i className="bi bi-trash"></i> Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
                {data.length === 0 && (
                  <tr>
                    <td colSpan="15" className="text-muted py-4">
                      No laptops found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Viewlaptop2025;
